import React from 'react'

const PricingCard = ({ title, price, features, highlighted }) => (
  <div
    className={`flex-1 flex flex-col bg-white rounded-xl p-8 m-2 transition-all duration-200 hover:shadow-xl ${
      highlighted ? 'relative mt-6' : 'mt-6'
    }`}
    style={{
      boxShadow: highlighted
        ? '0 13px 27px -5px rgba(50, 50, 93, 0.25), 0 8px 16px -8px rgba(0, 0, 0, 0.3)'
        : '0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07)',
      border: '1px solid #e3e8ee'
    }}
  >
    {/* Header */}
    <h3 className="text-lg font-semibold text-navy text-center mb-2">
      {title}
    </h3>

    {/* Price */}
    <div className="text-center mb-6">
      <span className="text-4xl font-bold text-navy">${price}</span>
      <span className="text-textMuted text-sm">/year</span>
    </div>

    {/* Features */}
    <ul className="flex-grow space-y-3 mb-8">
      {features.map((feature, idx) => (
        <li key={idx} className="flex items-start text-sm text-textSecondary">
          <svg
            className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5"
            style={{ color: '#33c27f' }}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
          {feature}
        </li>
      ))}
    </ul>

    {/* CTA Button */}
    <a
      href="tel:503-518-3384"
      className={`block text-center py-3 px-6 rounded-lg font-semibold text-sm transition-all duration-150 ${
        highlighted
          ? 'bg-primary text-white hover:bg-primaryDark'
          : 'bg-offWhite text-navy hover:bg-grey'
      }`}
      style={
        highlighted ? { boxShadow: '0 4px 14px 0 rgba(99, 91, 255, 0.39)' } : {}
      }
    >
      Call to Enroll
    </a>
  </div>
)

const Memberships = () => (
  <section className="py-24 px-6 bg-white">
    <div className="container mx-auto">
      {/* Section Header */}
      <div className="text-center mb-12">
        <div
          className="inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
          style={{
            background:
              'linear-gradient(135deg, rgba(99, 91, 255, 0.1) 0%, rgba(17, 239, 227, 0.1) 100%)',
            color: '#635bff'
          }}
        >
          Membership Plans
        </div>
        <h2 className="text-4xl font-bold text-navy mb-4">
          Affordable Dental Care for Everyone
        </h2>
        <p className="text-lg text-textSecondary max-w-2xl mx-auto">
          No insurance? No problem. Our membership plans offer comprehensive
          dental care at affordable prices with no hidden fees.
        </p>
      </div>

      {/* Pricing Cards */}
      <div className="flex flex-col lg:flex-row justify-center max-w-5xl mx-auto">
        <PricingCard
          title="Child Membership"
          price="300"
          features={[
            '2 Cleanings per year',
            '2 Periodic Exams',
            '2 Limited Exams',
            'Full mouth x-rays',
            'Annual check-up x-rays',
            'Oral Cancer Screening',
            '2 Fluoride Treatments',
            '20% savings on ALL treatments'
          ]}
        />

        <PricingCard
          title="Regular Adult Membership"
          price="400"
          features={[
            '2 Regular Cleanings',
            '2 Periodic Exams',
            '2 Limited Exams',
            'Full mouth x-rays',
            'Annual check-up x-rays',
            'Oral Cancer Screening',
            '2 Fluoride Treatments',
            '20% savings on ALL treatments'
          ]}
        />

        <PricingCard
          title="Adult Perio Membership"
          price="750"
          features={[
            '4 Periodontal Cleanings',
            '2 Periodic Exams',
            '2 Limited Exams',
            'Full mouth x-rays',
            'Annual check-up x-rays',
            'Oral Cancer Screening',
            '2 Fluoride Treatments',
            '20% savings on ALL treatments'
          ]}
        />
      </div>

      {/* Trust indicators */}
      <div className="text-center mt-12">
        <p className="text-sm text-textMuted">
          Plans include all family members living at the same address. No
          waiting periods or annual maximums.
        </p>
      </div>
    </div>
  </section>
)

export default Memberships
